// Chart date formatting matching the HTML report's "Jun 7, 2026, 14:37"
// style. "en-US" is pinned so output is stable regardless of viewer locale.

export const DAY_MS = 86_400_000;

const DATE_TIME_OPTS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

const DATE_OPTS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

/** e.g. "Jun 7, 2026, 14:37" */
export function formatChartDateTime(input: string | number | Date): string {
  return new Date(input).toLocaleString("en-US", DATE_TIME_OPTS);
}

/** e.g. "Jun 7, 2026" */
export function formatChartDate(input: string | number | Date): string {
  return new Date(input).toLocaleDateString("en-US", DATE_OPTS);
}

/**
 * A calendar date (`YYYY-MM-DD`, as the events API sends `event_date`) pinned to
 * local noon. `new Date("2026-06-08")` is parsed as UTC *midnight*, which every
 * consumer here then reads in local time — so for any viewer behind UTC the
 * event would render and plot one day early. Noon is the same calendar day in
 * every zone within ±12h, and mid-day is where a day-granularity event belongs
 * on a time axis anyway. Inputs that already carry a time pass through.
 */
export function calendarDateToLocalNoon(input: string): string {
  return /^\d{4}-\d{2}-\d{2}$/.test(input) ? `${input}T12:00:00` : input;
}
